<template>
  <div class="home">
    <SaleTermConditionList v-show="listView" @addTerm="onClickNewFromList" @editTerm="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <SaleTermConditionForm v-show="formView" :term="term" @backClicked="onBackChild" @backReload="backReload" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import SaleTermConditionList from '@/components/sales/SaleTermConditionList.vue'
import SaleTermConditionForm from '@/components/sales/SaleTermConditionForm.vue'
import { saleOrderUrl, getHeader } from '../config'

export default {
  name: 'SaleTermCondition',
  components: {
    SaleTermConditionList,
    SaleTermConditionForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      term: {
        id: null,
        term_no: null,
        term_name: null,
        term_date: null,
        notes: null
      }
    }
  },
  methods: {
    async backReload (id) {
      await axios.get(saleOrderUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.onClickEditFromList(response.data.data)
        })
        .catch(error => {
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.term = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      const date = new Date().toISOString()
      this.listView = false
      this.formView = true
      this.term = {
        id: null,
        term_no: null,
        term_name: null,
        term_date: date,
        notes: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.term = {
        id: null,
        term_no: null,
        term_name: null,
        term_date: null,
        notes: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  }
}
</script>
